/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Scope_Once_Only_TitleInputs */



/**
* | output |
* | --- |
* | "Just for this one" |
*
* @param {Meeting_Scope_Once_Only_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_scope_once_only_title = /** @type {((inputs?: Meeting_Scope_Once_Only_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Scope_Once_Only_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Alleen voor deze keer")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour cette fois seulement")
	return /** @type {LocalizedString} */ ("Just for this one")
});